// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const CLICK_HERE_TO_ENTER_DESCRIPTION = "Klikni sem a zadej popis";
export const GO_BACK_TO_GROUP_POST = "Zp\u011bt na zpr\u00e1vu";
export const IMAGE_REMOVE_COMPLAINTS = "Zru\u0161 nahl\u00e1\u0161en\u00ed obr\u00e1zku";
